<template>
  <div class="props-group">
      <div class="private">
        <el-form-item label="日期类型">
          <el-select placeholder="请选择" v-model='component.archive.dataType'>
            <el-option label="日期" value="date"></el-option>
            <el-option label="日期+时间" value="dateTime"></el-option>
            <el-option label="时间" value="time"></el-option>
          </el-select>
        </el-form-item>
      </div>
  </div>
</template>
<script>
export default {
  name: 'attr-date-type',
  props: ['component']
}
</script>

<style lang="scss">
  .private {
    border-top: 1px solid #c2c3c4;
    margin: 0 -20px;
    padding: 0 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/form/componentAttr/date-type.vue